// Job service constants and configuration

export const JOB_STATUSES = {
  SCHEDULED: 'scheduled',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

export const SERVICE_TYPES = {
  INSPECTION: 'inspection',
  TREATMENT: 'treatment',
  MAINTENANCE: 'maintenance',
  EMERGENCY: 'emergency'
};

export const VALID_STATUSES = [
  JOB_STATUSES.SCHEDULED,
  JOB_STATUSES.IN_PROGRESS,
  JOB_STATUSES.COMPLETED,
  JOB_STATUSES.CANCELLED
];

export const VALID_SERVICE_TYPES = [
  SERVICE_TYPES.INSPECTION,
  SERVICE_TYPES.TREATMENT,
  SERVICE_TYPES.MAINTENANCE,
  SERVICE_TYPES.EMERGENCY
];

export const STATUS_DISPLAY_MAP = {
  [JOB_STATUSES.SCHEDULED]: 'Scheduled',
  [JOB_STATUSES.IN_PROGRESS]: 'In Progress',
  [JOB_STATUSES.COMPLETED]: 'Completed',
  [JOB_STATUSES.CANCELLED]: 'Cancelled'
};

export const SERVICE_TYPE_DISPLAY_MAP = {
  [SERVICE_TYPES.INSPECTION]: 'Inspection',
  [SERVICE_TYPES.TREATMENT]: 'Treatment',
  [SERVICE_TYPES.MAINTENANCE]: 'Maintenance',
  [SERVICE_TYPES.EMERGENCY]: 'Emergency'
};

export const STATUS_COLOR_MAP = {
  [JOB_STATUSES.SCHEDULED]: 'bg-blue-100 text-blue-800',
  [JOB_STATUSES.IN_PROGRESS]: 'bg-yellow-100 text-yellow-800',
  [JOB_STATUSES.COMPLETED]: 'bg-green-100 text-green-800',
  [JOB_STATUSES.CANCELLED]: 'bg-red-100 text-red-800'
};

export const VALIDATION_RULES = {
  DURATION: { min: 15, max: 1440 },
  ACTUAL_DURATION: { min: 1, max: 1440 },
  PRICE: { min: 0 }
};

export const CSV_HEADERS = [
  'Category',
  'Customer',
  'Service Type', 
  'Status',
  'Scheduled Date',
  'Technician',
  'Price',
  'Duration (Est.)',
  'Duration (Actual)',
  'Created Date'
];

export const FILE_ICONS = {
  IMAGE: '🖼️',
  PDF: '📄',
  WORD: '📝',
  EXCEL: '📊',
  DEFAULT: '📎'
};

export const FILE_SIZE_UNITS = ['Bytes', 'KB', 'MB', 'GB'];